import React, { useState } from "react";
import "./login.css";
import LeftPanel from "./leftPanel";
import { Form, Formik } from "formik";
import * as yup from "yup";
import CustomInput from "../../components/CustomInput/CustomInput";
import apiUtil from "../../api/apiUtil";
import api from "../../api/api";
import secureLocalStorage from "react-secure-storage";

const Login = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(
    JSON.parse(localStorage.getItem("user"))
  );
  console.log(isAuthenticated);
  const [isBIM, setIsBIM] = useState(true);
  const [isPartner, setIsPartner] = useState(false);
  const [isRemember, setIsRemember] = useState(
    localStorage.getItem("remember") === "true"
  );

  const [isOrganization, setIsOrganization] = useState(true);
  const [isIndividual, setIsIndividual] = useState(false);

  const RememberMe = (e) => {
    const isChecked = e.target.checked;
    setIsRemember(isChecked);
    if (!isChecked) {
      secureLocalStorage.removeItem("username");
      secureLocalStorage.removeItem("password");
    }
  };

  const handleSubmit = async (values, actions) => {
    console.log(values);
    const user = {
      userName: values.username,
      password: values.password,
      userType: values.loginType,
    };

    if (isRemember) {
      secureLocalStorage.setItem("username", values.username);
      secureLocalStorage.setItem("password", values.password);
    }

    api.post("Authentication/Authenticate", user).then((result) =>
      apiUtil.parseResult(
        result,
        (response) => {
          console.log(response);

          if (response.data.code === 200) {
            setIsAuthenticated(true);
            if (isRemember) {
              localStorage.setItem("remember", true);
            } else {
              localStorage.removeItem("remember");
            }
            localStorage.setItem("user", JSON.stringify(response.data.data));
            localStorage.setItem("brandId", response.data.data.brandId);
            window.location.href = "/";
          } else {
            alert(response.data.message);
          }
        },
        (error) => {
          console.log(error);
        }
      )
    );

    actions.setSubmitting(false);
  };
  const onClickBtn = () => {
    setIsBIM(!isBIM);
    setIsPartner(!isPartner);
  };

  let schema = yup.object().shape({
    username: yup.string().required("Please enter the username."),
    password: yup
      .string()
      .required("Please enter the password.")
      .test("len", "Password must be at least 8 characters.", (val) =>
        val && val.length >= 8
      ),
  });

  return (
    <div className="d-flex container-fluid">
      <div className="col-6 leftPanel">
        <LeftPanel />
      </div>
      <div className="col-6 bg-white">
        <div className="rightPanel">
          <div className="d-flex justify-content-end w-100 m-0">
            <button
              className={`leftBtn rightBtn ${isBIM ? "btn_Active" : ""}`}
              onClick={onClickBtn}
            >
              Sedona
            </button>
            {/* <button
              className={`rightBtn ${isPartner ? "btn_Active" : ""}`}
              onClick={onClickBtn}
            >
              Sedona
            </button> */}
          </div>

          <div className={`loginForm ${!isBIM && "PTR-form"}`}>
            <Formik
              initialValues={{
                username: isRemember ? secureLocalStorage.getItem("username") || "" : "",
                password: isRemember ? secureLocalStorage.getItem("password") || "" : "",
                loginType: "1",
              }}
              validationSchema={schema}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, setFieldValue }) => {
                return (
                  <Form className="wrapper">
                    <h4 className="title">Please login to your dashboard</h4>
                    {!isBIM && (
                      <div className="radioButtonContainer">
                        <label
                          className={`organizationHolder ${isOrganization ? "btn_Active" : ""}`}
                          onClick={() => {
                            values.loginType = "1";
                            setIsOrganization(true);
                            setIsIndividual(false);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              setIsIndividual(false);
                            }
                          }}
                        >
                          Organization<input
                            type="radio"
                            name="loginType"
                            value="1"
                            checked={values.loginType === "1"}
                            onChange={() => console.log(values.loginType)}
                          />
                          <span className="radio-item-1"></span>
                        </label>
                        <label
                          className={`individualHolder ${isIndividual ? "btn_Active" : ""}`}
                          onClick={() => {
                            values.loginType = "2";
                            setIsOrganization(false);
                            setIsIndividual(true);
                          }}
                          onKeyDown={(e) => {
                            if (e.key === "Enter" || e.key === " ") {
                              setIsOrganization(false);
                            }
                          }}
                        >
                          Brand<input
                            type="radio"
                            name="loginType"
                            value="2"
                            checked={values.loginType === "2"}
                            onChange={() => console.log(values.loginType)}
                          />
                          <span className="radio-item-2"></span>
                        </label>

                      </div>
                    )}
                    <CustomInput
                      name="username"
                      type="username"
                      placeholder="Username"
                      customclass="input_wrapper input_username"
                    />
                    <div className="mt-3"></div>
                    <CustomInput
                      name="password"
                      type="password"
                      placeholder="Password"
                      customclass="input_wrapper input_password"
                    />

                    <div className="toggle-switch mt-3">
                      <span className="remember">
                        Remember me
                      </span>
                      <label htmlFor="remember" className="switch">
                        <input
                          type="checkbox"
                          id="remember"
                          name="remember"
                          checked={isRemember}
                          onChange={RememberMe}
                        />
                        <span className="slider round"></span>
                      </label>
                    </div>
                    <button className="login_btn" type="submit">
                      Login
                    </button>
                  </Form>
                );
              }}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
